"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.isempty"));

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _uiKit = require("@devsta/ui-kit");

var _SeatsInput = _interopRequireDefault(require("./SeatsInput"));

require("../styles/_create-team.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CreateTeamModal = /*#__PURE__*/function (_Component) {
  _inherits(CreateTeamModal, _Component);

  function CreateTeamModal(props) {
    var _this;

    _classCallCheck(this, CreateTeamModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CreateTeamModal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", (0, _lodash.default)(function (fieldName) {
      return function (_ref) {
        var value = _ref.target.value;

        _this.setState(_defineProperty({}, fieldName, value));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleSeatsChange", function (value) {
      _this.setState({
        userAllowance: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchUsers", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(searchTerm) {
        var searchOrgMemberships, _ref3, data, error;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                searchOrgMemberships = _this.props.searchOrgMemberships;

                if (!(0, _lodash2.default)(searchTerm)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", []);

              case 3:
                _context.next = 5;
                return searchOrgMemberships({
                  searchTerm: searchTerm.toLowerCase()
                });

              case 5:
                _ref3 = _context.sent;
                data = _ref3.data;
                error = _ref3.error;

                if (!(error || !data || !data.searchOrgMemberships)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", []);

              case 10:
                return _context.abrupt("return", data.searchOrgMemberships.map(function (_ref4) {
                  var _ref4$user = _ref4.user,
                      userId = _ref4$user.userId,
                      firstName = _ref4$user.firstName,
                      lastName = _ref4$user.lastName,
                      imageUrl = _ref4$user.imageUrl;
                  return {
                    label: (0, _getUserFullName.default)({
                      firstName: firstName,
                      lastName: lastName
                    }),
                    value: userId,
                    prefix: _react.default.createElement(_uiKit.Image, {
                      imageUrl: imageUrl,
                      placeholderText: (0, _getUserFullName.default)({
                        firstName: firstName,
                        lastName: lastName
                      }),
                      placeholderTextSize: 12,
                      height: "25px",
                      width: "25px",
                      circular: true
                    })
                  };
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onAdminSelected", function (selectedUserOption) {
      _this.setState({
        selectedUserOption: selectedUserOption,
        adminUserId: selectedUserOption.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validate", function () {
      var remainingUsersNumber = _this.props.remainingUsersNumber;
      var _this$state = _this.state,
          name = _this$state.name,
          description = _this$state.description,
          userAllowance = _this$state.userAllowance,
          adminUserId = _this$state.adminUserId;
      var isUserAllowanceValid = remainingUsersNumber === -1 ? true : Boolean(userAllowance);
      return name && description && isUserAllowanceValid && adminUserId;
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, createTeam, onTeamCreated, onClose, remainingUsersNumber, _this$state2, name, description, adminUserId, userAllowance, teamType, userAllowanceToSave, _ref6, data, error, members;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, createTeam = _this$props.createTeam, onTeamCreated = _this$props.onTeamCreated, onClose = _this$props.onClose, remainingUsersNumber = _this$props.remainingUsersNumber;
              _this$state2 = _this.state, name = _this$state2.name, description = _this$state2.description, adminUserId = _this$state2.adminUserId, userAllowance = _this$state2.userAllowance, teamType = _this$state2.teamType;
              userAllowanceToSave = remainingUsersNumber === -1 ? -1 : userAllowance;
              _context2.next = 5;
              return createTeam({
                name: name,
                description: description,
                adminUserId: adminUserId,
                type: teamType.value,
                userAllowance: userAllowanceToSave
              });

            case 5:
              _ref6 = _context2.sent;
              data = _ref6.data;
              error = _ref6.error;

              if (!error) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return");

            case 10:
              _this.setState({
                name: void 0,
                description: void 0,
                selectedUserOption: void 0,
                adminUserId: void 0,
                userAllowance: 0
              });

              members = data.createTeam.members;
              onTeamCreated(_objectSpread({}, data.createTeam, {
                membersCount: members.length,
                membersPreview: members.map(function (_ref7) {
                  var user = _ref7.user;
                  return user.imageUrl;
                }).filter(Boolean)
              }));
              onClose();

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onSelectTeamType", function (teamType) {
      _this.setState({
        teamType: teamType
      });
    });

    _this.state = {
      name: void 0,
      description: void 0,
      userAllowance: 0,
      selectedUserOption: void 0,
      teamType: {
        label: 'GENERAL',
        value: 'ORGANISATION'
      },
      adminUserId: void 0
    };
    return _this;
  }

  _createClass(CreateTeamModal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          onClose = _this$props2.onClose,
          remainingUsersNumber = _this$props2.remainingUsersNumber;
      var _this$state3 = this.state,
          name = _this$state3.name,
          description = _this$state3.description,
          selectedUserOption = _this$state3.selectedUserOption,
          userAllowance = _this$state3.userAllowance,
          teamType = _this$state3.teamType;
      return _react.default.createElement("div", {
        className: "create-team"
      }, _react.default.createElement(_uiKit.FormModal, {
        key: "create-team-modal",
        title: "Create New Team",
        visible: visible,
        onClose: onClose,
        onSave: this.handleModalSave,
        saveDisabled: !this.validate(),
        stayOpenOnSave: true
      }, _react.default.createElement("p", {
        className: "create-team__header"
      }, "Team Details"), visible ? _react.default.createElement("div", {
        className: "create-team__details"
      }, _react.default.createElement(_uiKit.Input, {
        label: "Team Name*",
        placeholder: "Enter team name",
        defaultValue: name,
        onChange: this.handleInputChange('name')
      }), remainingUsersNumber === -1 ? null : _react.default.createElement(_SeatsInput.default, {
        label: "Allocated Seats*",
        seats: userAllowance,
        min: 0,
        max: remainingUsersNumber,
        onChange: this.handleSeatsChange
      }), _react.default.createElement(_uiKit.Dropdown, {
        id: "team-type",
        label: "Team Type*",
        onChange: this.onSelectTeamType,
        defaultValue: teamType,
        options: [{
          label: 'GENERAL',
          value: 'ORGANISATION'
        }, {
          label: 'EDITING',
          value: 'EDITING'
        }],
        upperCaseLabels: true
      }), _react.default.createElement(_uiKit.Input, {
        multiline: true,
        className: "create-team__details__description",
        label: "Description*",
        placeholder: "Enter team description",
        defaultValue: description,
        onChange: this.handleInputChange('description')
      }), _react.default.createElement(_uiKit.Dropdown, {
        id: "team-admin",
        label: "Team Admin*",
        placeholder: "Select from the list below",
        onChange: this.onAdminSelected,
        defaultValue: selectedUserOption,
        defaultOptions: true,
        options: [],
        loadOptions: this.searchUsers,
        isSearchable: true,
        upperCaseLabels: true
      })) : null));
    }
  }]);

  return CreateTeamModal;
}(_react.Component);

exports.default = CreateTeamModal;